<div class="flow_header">
  <span class="controlListItem_iconBackground">
  <img class="controlListItem_icon" src='../../../assets/svg/Union.svg'/></span>
  <label class="flow_label">Manage Placeholder</label>
  <div class="flow_img_container">
    <div class="flow_img_btn" (click)="closeModal()"></div>
  </div>
</div>
<div class="main-body">
  <div class="placeholderDetails">
    <!--Form-->
    <div [formGroup]="botForm" class="form_content">
      <div class="lhs">
        <div class="first_column">
          <div class="item first_row">
            <button class="addPages"> Add Page</button>
          </div>
        </div>
        <div class="second_column">
          <mat-accordion multi>
            <mat-expansion-panel class="matExpansionDetails">
              <mat-expansion-panel-header>
                <mat-panel-title>
                  <mat-icon class="page"></mat-icon>
                  <p class="centerAlign"> Page 1</p>
                  <mat-icon class="removePage"></mat-icon>
                </mat-panel-title>
              </mat-expansion-panel-header>
              <div class="placeholderItem spacer"(click)="setHighLight()">
                <mat-icon class="dot-matrix"></mat-icon>
                <img class="placeholderItem_icon" src='../../../assets/svg/Union.svg'/>
                Placeholder_1
              </div>
              <div class="placeholderItem spacer" (click)="setHighLight()">
                <mat-icon class="dot-matrix"></mat-icon>
                <img class="placeholderItem_icon" src='../../../assets/svg/Union.svg'/>
                Placeholder_2
              </div>
              <button class="addPlaceholder"> Add Placeholder</button>
            </mat-expansion-panel>

            <mat-expansion-panel class="matExpansionDetails">
              <mat-expansion-panel-header>
                <mat-panel-title>
                  <mat-icon class="page"></mat-icon>
                  <p class="centerAlign"> Page 2</p>
                  <mat-icon class="removePage"></mat-icon>
                </mat-panel-title>
              </mat-expansion-panel-header>
              <div class="placeholderItem spacer selected" (click)="setHighLight()">
                <mat-icon class="dot-matrix"></mat-icon>
                <img class="placeholderItem_icon" src='../../../assets/svg/Union.svg'/>
                Placeholder_1
              </div>
              <div class="placeholderItem spacer" (click)="setHighLight()">
                <mat-icon class="dot-matrix"></mat-icon>
                <img class="placeholderItem_icon" src='../../../assets/svg/Union.svg'/>
                Placeholder_2
              </div>
              <button class="addPlaceholder"> Add Placeholder</button>
            </mat-expansion-panel>

          </mat-accordion>
        </div>
      </div>
      <div class="rhs">
        <div class="container">

          <div class="item first_row">
            <div class="labelGroup">
              <div class="label_title">Placeholder ID</div>
            </div>
            @if ((botForm.controls['displayName'].invalid && botForm.controls['displayName'].touched) &&
              !(botForm.controls['placeholderId'].invalid && botForm.controls['placeholderId'].touched)) {
              <div class="item_label_error space "
                >
              </div>
            }
            @if (botForm.controls['placeholderId'].invalid && botForm.controls['placeholderId'].touched) {
              <div class="item_label_error "
                >
                Placeholder id is required
              </div>
            }
            <input formControlName="placeholderId" class="item_input"
              placeholder="Enter Placeholder ID"/>
            </div>

            <div class="item first_row align_second_column">
              <div class="labelGroup">
                <div class="label_title">Display Name</div>
              </div>
              @if ((botForm.controls['placeholderId'].invalid && botForm.controls['placeholderId'].touched) &&
                !(botForm.controls['displayName'].invalid && botForm.controls['displayName'].touched)) {
                <div class="item_label_error space "
                  >
                </div>
              }
              @if (botForm.controls['displayName'].invalid && botForm.controls['displayName'].touched) {
                <div class="item_label_error "
                  >
                  Display Name is required
                </div>
              }

              <input formControlName="displayName" placeholder="Enter Display Name"
                class="item_input"/>
              </div>
            </div>
            <div class="container">
              <div class="item second_row">

                <div class="labelGroup">
                  <div class="label_title">Description</div>
                </div>

                @if (botForm.controls['description'].invalid && botForm.controls['description'].touched) {
                  <div class="item_label_error "
                    >
                    Description is required
                  </div>
                }
                @if ((botForm.controls['dataType'].invalid && botForm.controls['dataType'].touched) &&
                  !(botForm.controls['description'].invalid && botForm.controls['description'].touched)) {
                  <div class="item_label_error space "
                    >
                  </div>
                }
                <input formControlName="description" placeholder="Add Description"
                  class="item_input"/>
                </div>

                <div class="item second_row align_second_column">
                  <div class="labelGroup">
                    <mat-label class="label_title">Data Type</mat-label>
                    @if (botForm.controls['dataType'].invalid && botForm.controls['dataType'].touched) {
                      <div class="item_label_error "
                        >
                        Data Type is required
                      </div>
                    }
                    @if ((botForm.controls['description'].invalid && botForm.controls['description'].touched) &&
                      !(botForm.controls['dataType'].invalid && botForm.controls['dataType'].touched)) {
                      <div class="item_label_error space "
                        >
                      </div>
                    }
                    <mat-select placeholder="Select a Data Type" class="item_input">
                      <mat-option value="Pdf">PDF</mat-option>
                      <mat-option value="media">MEDIA</mat-option>
                      <mat-option value="video">VIDEO</mat-option>
                    </mat-select>

                  </div>

                </div>
              </div>

              <div class="container">
                <div class="item third_row labelMinMaxGroup">
                  <div class="labelGroup">
                    <div class="label_title">Min Length</div>
                    <div class="label_optional">Optional</div>
                  </div>
                  <div class="minMaxGroup">
                    <button class="btn btn-default minus"></button>
                    <input formControlName="minLength" value="0" class="item_input minMaxInput" [ngModel]="0"
                      type="number" name="Quantity"/>
                      <button class="btn btn-default plus"></button>
                    </div>
                  </div>

                  <div class=" item third_row align_second_column labelMinMaxGroup ">
                    <div class="labelGroup">
                      <div class="label_title">Max Length</div>
                      <div class="label_optional">Optional</div>
                    </div>
                    <div class="minMaxGroup">
                      <button class="btn btn-default minus"></button>
                      <input formControlName="maxLength" value="0" class="item_input minMaxInput" [ngModel]="0"
                        type="number" name="Quantity"/>
                        <button class="btn btn-default plus"></button>
                      </div>
                    </div>
                  </div>

                  <div class="container">
                    <div class="item fourth_row ">
                      <div class="labelGroup">
                        <div class="label_title">Regular Expression</div>
                        <div class="label_optional">Optional</div>
                      </div>
                      <input formControlName="regularExpression" placeholder="Enter Regex"
                        class="item_input"/>
                      </div>

                      <div class="item fourth_row align_second_column">
                        <div class="labelGroup">
                          <div class="label_title">Hint</div>
                          <div class="label_optional">Optional</div>
                        </div>
                        <input formControlName="hint" placeholder="Add Hint"
                          class="item_input"/>
                        </div>
                      </div>

                      <div class="container">
                        <div class="item fifth_row ">
                          <div class="labelGroup prepop">
                            <div class="label_title">Pre-Populated Value</div>
                            <div class="label_optional ">Optional</div>
                          </div>
                          <input formControlName="prepopulatedValue" placeholder="Add Pre-Populated Value"
                            class="item_input"/>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="flow_save_new_buttonsContainer">
                    <button class="flow_save_new_cancelBtn" (click)="closeModal()">Cancel</button>
                    <button (click)="closeModal()" class="flow_save_new_saveBtn">Save Placeholders</button>
                  </div>
                </div>